import { render, staticRenderFns } from "./VoucherTabItem.vue?vue&type=template&id=2c4eb206&scoped=true"
import script from "./VoucherTabItem.vue?vue&type=script&lang=js"
export * from "./VoucherTabItem.vue?vue&type=script&lang=js"
import style0 from "./VoucherTabItem.vue?vue&type=style&index=0&id=2c4eb206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4eb206",
  null
  
)

export default component.exports